import { FIELD_INCORRECTLY } from '../constants/validationErrors';

export function makeInnChecksumVerification() {
  return (value?: string) => {
    if (!value) {
      return FIELD_INCORRECTLY;
    }

    return checksum(value) ? undefined : FIELD_INCORRECTLY;
  };
}

function checksum(inn: string) {
  let isValidChecksum = false;

  const checkedValueArray = inn.split('').map(Number);

  const checkDigit = (innNumberArray: number[], coefficients: number[]) => {
    let n = 0;

    Object.values(coefficients).forEach((value, index) => {
      n += value * checkedValueArray[index];
    });

    return parseInt(String((n % 11) % 10), 10);
  };

  switch (inn.length) {
    case 10: {
      const n10 = checkDigit(checkedValueArray, [2, 4, 10, 3, 5, 9, 4, 6, 8]);

      if (n10 === parseInt(inn[9], 10)) {
        isValidChecksum = true;
      }
      break;
    }
    case 12: {
      const n11 = checkDigit(checkedValueArray, [7, 2, 4, 10, 3, 5, 9, 4, 6, 8]);

      const n12 = checkDigit(checkedValueArray, [3, 7, 2, 4, 10, 3, 5, 9, 4, 6, 8]);

      if (n11 === parseInt(inn[10], 10) && n12 === parseInt(inn[11], 10)) {
        isValidChecksum = true;
      }
      break;
    }
    default:
      break;
  }

  return isValidChecksum;
}
